

export const dateFormat = 'MM-DD-YYYY hh:mm A';



// table constants
export const TABLE_COLUMN_LIST = [
    {
        title: 'User ID', data: 'userId',
        render(_data: any, _type: any, _full: any) {
            if (_full.userId !== undefined && _full.userId !== null) {
                return _full.userId;
            }
            return '';
        }
    },
    {
        title: 'Device ID', data: 'deviceId',
        render(_data: any, _type: any, _full: any) {
            if (_full.deviceId !== undefined && _full.deviceId !== null) {
                return _full.deviceId;
            }
            return '';
        }
    },
    {
        title: 'Cyberscore', data: 'cyberScore',
        render(_data: any, _type: any, _full: any) {
            if (_full.cyberScore !== undefined && _full.cyberScore !== null) {
                return _full.cyberScore;
            }
            return '';
        }
    },
    {
        title: 'Cyberscore Threshold', data: 'cyberScoreThreshold',
        render(_data: any, _type: any, _full: any) {
            if (_full.cyberScoreThreshold !== undefined && _full.cyberScoreThreshold !== null) {
                return _full.cyberScoreThreshold;
            }
            return '';
        }
    },
    {
        title: 'Logins Below Threshold', data: 'failureAttemptsNumber',
        render(_data: any, _type: any, _full: any) {
            if (_full.failureAttemptsNumber !== undefined && _full.failureAttemptsNumber !== null) {
                return _full.failureAttemptsNumber;
            }
            return '';
        }
    },
    { title: 'Time', data: 'time' }
];

export const TABLE_COLUMN_LIST_FAILED = [
    {
        title: 'User ID', data: 'userId',
        render(_data: any, _type: any, _full: any) {
            if (_full.userId !== undefined && _full.userId !== null) {
                return _full.userId;
            }
            return '';
        }
    },
    {
        title: 'Device ID', data: 'deviceId',
        render(_data: any, _type: any, _full: any) {
            if (_full.deviceId !== undefined && _full.deviceId !== null) {
                return _full.deviceId;
            }
            return '';
        }
    },
    {
        title: 'Cyberscore', data: 'cyberScore',
        render(_data: any, _type: any, _full: any) {
            if (_full.cyberScore !== undefined && _full.cyberScore !== null) {
                return _full.cyberScore;
            }
            return '';
        }
    },
    {
        title: 'Cyberscore Threshold', data: 'cyberScoreThreshold',
        render(_data: any, _type: any, _full: any) {
            if (_full.cyberScoreThreshold !== undefined && _full.cyberScoreThreshold !== null) {
                return _full.cyberScoreThreshold;
            }
            return '';
        }
    },
    { title: 'Time', data: 'time' }
];


export function createButtonElement(id: string, name: string) {
    const button = document.createElement('button');
    button.id = id;
    button.name = name;
    button.title = 'View Failure Reasons';
    button.innerHTML = 'View';
    button.className = 'failure-link';


    return button.outerHTML;
}

export function createAnchorLink(id: string, name: string) {
    const link = document.createElement('a');
    const text = document.createTextNode('View');
    link.append(text);
    link.id = id;
    link.title = 'View Failure Reasons';
    link.innerHTML = 'View';
    link.className = 'failure-link';
    link.style.color = 'orangered';

    var css = 'a:hover{ font-weight: bold; text-decoration: underline;  cursor: pointer;} ';
    var style = document.createElement('style') as HTMLStyleElement;

    style.appendChild(document.createTextNode(css));

    link.append(style);

    return link.outerHTML;
}



export const PAGE_DROPDOWN_DEFAULT = 10;
export const PAGE_DROPDOWN = [20, 30, 50, PAGE_DROPDOWN_DEFAULT].sort((a, b) => a - b);

export const DEFAULT_DT_OPTION_SUCCESS: DataTables.Settings = {
    pageLength: PAGE_DROPDOWN_DEFAULT,
    language: {
        searchPlaceholder: "Enter User ID"
    },
    paging: true,
    searching: true,
    serverSide: true,
    processing: true,
    order: [[5, 'asc']],
    columnDefs: [
        {
            targets: [0],
            searchable: true,
            orderable: true
        },
        {
            targets: [1, 2, 3, 5],
            searchable: false,
            orderable: true
        },
        {
            targets: [4, 6],
            searchable: false,
            orderable: false
        },
        {
            targets: [5],
            type: 'date'
        },


    ]
};

export const DEFAULT_DT_OPTION_FAILED: DataTables.Settings = {
    pageLength: PAGE_DROPDOWN_DEFAULT,
    language: {
        searchPlaceholder: "Enter User ID"
    },
    paging: true,
    searching: true,
    serverSide: true,
    processing: true,
    retrieve: true,
    order: [[4, 'asc']],
    columnDefs: [
        {
            targets: [0],
            searchable: true,
            orderable: true
        },
        {
            targets: [1, 2, 3, 4],
            searchable: false,
            orderable: true
        },
        {
            targets: [5],
            searchable: false,
            orderable: false
        },
        {
            targets: [4],
            type: 'date'
        },

    ]
};